import { render, staticRenderFns } from "./step_description_transport_engineering.vue?vue&type=template&id=64c9c536&scoped=true"
import script from "./step_description_transport_engineering.vue?vue&type=script&lang=js"
export * from "./step_description_transport_engineering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c9c536",
  null
  
)

export default component.exports